export default __webpack_public_path__ + "static/media/enchantment.df276914.svg";